import type { EditToolColorValues } from '@carboncopyco/types';
import { TinyColor } from '@ctrl/tinycolor';

export function getRandomHEXColor(): string {
  const randomColor = Math.floor(Math.random() * 16777215).toString(16);
  return `#${randomColor}`;
}

export function getAlpha(rgb: string): number {
  return new TinyColor(rgb).getAlpha();
}

export function convertToHex(color: any): string {
  return new TinyColor(color).toHex8String();
}

export function convertToRgb(color: any): EditToolColorValues {
  return new TinyColor(convertToHex(color)).toRgb();
}
